window.jQuery = window.$ = require('jquery');
require('svg4everybody');
require('./components/spinner');
require('./thirdParty/bootstrap');
require('slick-carousel/slick/slick');

if (!('loading' in HTMLImageElement.prototype)) {
    require('lazysizes');
}
